// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Cookies from 'vue-cookies'
import config from './assets/js/config.js'
import store from './store'
import dayjs from 'dayjs'
Vue.prototype.dayjs = dayjs
import scroll from 'vue-seamless-scroll'
import App from './App'
import router from './router'
Vue.use(scroll)
import VueAxios from 'vue-axios'
import instance from '../src/assets/js/http.js'

Vue.prototype.config = config
Vue.prototype.api = config.api
Vue.use(ElementUI)
Vue.use(router)
Vue.use(Cookies)
Vue.use(store)
Vue.config.productionTip = false

Vue.use(VueAxios, instance)
Vue.config.devtools = false



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: function () {
    return {
      intTestData: null  //初始化测试数据
    }
  },
  components: {
    App
  },
  template: '<App/>',
})



// WEBPACK FOOTER //
// ./src/main.js